import * as Sentry from '@sentry/react';

/**
 * Inicializa Sentry no boot do portal. Chamado uma vez em `index.js` ANTES
 * de qualquer render — `Sentry.init` registra handlers globais (unhandled
 * error, promise rejection). Idempotente: sem DSN pula (dev sem Sentry).
 *
 * `REACT_APP_SENTRY_DSN` — write-only endpoint (não permite leitura), pode
 * ficar em `.env` versionado.
 * `REACT_APP_SENTRY_ENVIRONMENT` — dev/staging/prod. Vem por variant do CI
 * (deploy-staging.yml e deploy-prod.yml sobrescrevem). Default = development.
 */
export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) {
    console.warn('[Sentry] REACT_APP_SENTRY_DSN not set — skipping init');
    return;
  }
  const environment = process.env.REACT_APP_SENTRY_ENVIRONMENT || 'development';
  Sentry.init({
    dsn,
    environment,
    // Sampling — prod amostra 10% de traces; dev/staging 100%. Errors são
    // sempre 100% (nunca fazem sample).
    tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
    // Auto-capture unhandled promise rejections + window.onerror já ligados por default.
  });
}
